import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from "react";
import ReactDOM from "react-dom";
import LoginModule from "./src/Login/Module";

ReactDOM.render(
    <React.StrictMode>
        <LoginModule />
    </React.StrictMode>,
    document.getElementById("flow-login-module")
);
